import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'



const DocumentListPageUI = ({ context, errorList, onRefreshClick, account, loanList,


}) =>

  <SuperUserAccountPageUI context={context} className='pg_su_dl' headerText={account && account.accountName}
    centered={!loanList} page='documents' backLink='/su/accounts' account={account}
  >
    {
      !loanList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }


    {
      loanList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Documents</b></span>
            </div>
          }
          right={
            <span>

            </span>
          }
        />

        <div>
          <CardUI className='g_m_bottom_100'>
            <table>
              <thead className='g_sticky'>
                <tr className='head'>
                  <th>Document</th>
                  <th>Loan Name</th>
                  <th >Sign/Accept Date</th>
                  <th >Template</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {
                  loanList && loanList.filter(loan => loan.termSheet && loan.termSheet.status !== 'not_initiated').map((loan, i) =>
                    <>
                      <tr key={i}>
                        <td >Term Sheet</td>
                        <td className='g_p_left_100'>
                          <Link to={`/su/loans/${loan.loanId}/esigning`}>
                            {loan.loanName}
                          </Link></td>
                        <td className='g_p_left_100'>{loan.termSheet.acceptDateF1}</td>
                        <td className='g_p_left_100'>{loan.termSheet.templateName}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='g_p_left_100'>{loan.termSheet.version}</td>
                      </tr>
                    </>
                  )
                }
                {
                  loanList && loanList.filter(loan => loan.resolutionSign && loan.resolutionSign.status !== 'not_initiated').map((loan, i) =>
                    <>
                      <tr key={i}>
                        <td >Resolutions</td>
                        <td className='g_p_left_100'>
                          <Link to={`/su/loans/${loan.loanId}/esigning`}>
                            {loan.loanName}
                          </Link></td>
                        <td className='g_p_left_100'>{loan.resolutionSign.signDateF1}</td>
                        <td className='g_p_left_100'>{loan.resolutionSign.templateName}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='g_p_left_100'>{loan.resolutionSign.version}</td>
                      </tr>
                    </>
                  )
                }
                {
                  loanList && loanList.map((loan, i) => (
                    <>
                      {
                        loan.agreementSignList && loan.agreementSignList.filter(agr => agr.status !== 'not_initiated').map((agr, j) => (
                          <>
                            <tr key={i}>
                              <td>{agr.name}</td>
                              <td className='g_p_left_100'>
                                <Link to={`/su/loans/${loan.loanId}/esigning`}>
                                  {loan.loanName}
                                </Link></td>
                              <td></td>
                              <td className='g_p_left_100'>{agr.templateName}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className='g_p_left_100'>{agr.version}</td>
                            </tr>
                          </>
                        ))
                      }
                    </>
                  ))
                }
              </tbody>
            </table>
          </CardUI>
        </div>
      </div>
    }

  </SuperUserAccountPageUI >

export default DocumentListPageUI
